import { render, staticRenderFns } from "./PanelCompetitionCreate.vue?vue&type=template&id=1ac84d31&scoped=true&"
import script from "./PanelCompetitionCreate.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionCreate.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionCreate.vue?vue&type=style&index=0&id=1ac84d31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac84d31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ac84d31')) {
      api.createRecord('1ac84d31', component.options)
    } else {
      api.reload('1ac84d31', component.options)
    }
    module.hot.accept("./PanelCompetitionCreate.vue?vue&type=template&id=1ac84d31&scoped=true&", function () {
      api.rerender('1ac84d31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionCreate.vue"
export default component.exports